import type { PortfolioDetailResponseDTO } from "web_myplann/Infrastructure/Api/Api";
import { CRYPTOCURRENCY_FORM_DEFAULT_VALUES as DEFAULTS } from "web_myplann/Portfolio/Forms/CryptocurrencyForm/cryptocurrencyFormDefaults";
import type { CryptocurrencyFormInput } from "web_myplann/Portfolio/Forms/CryptocurrencyForm/cryptocurrencyFormSchema";
import { parseIsoDate } from "web_myplann/Portfolio/Forms/dateParsers";

export const mapPortfolioToCryptocurrencyForm = (
	portfolio: PortfolioDetailResponseDTO,
): CryptocurrencyFormInput => {
	return {
		name: portfolio.name ?? DEFAULTS.name,
		contractNumber: portfolio.contractNumber ?? DEFAULTS.contractNumber,
		producer: portfolio.producer ?? DEFAULTS.producer,
		product: portfolio.product ?? DEFAULTS.product,
		productCategoryId:
			portfolio.productCategoryId ?? DEFAULTS.productCategoryId,
		signedAt: parseIsoDate(portfolio.signedAt),
		startAt: parseIsoDate(portfolio.startAt),
		endAt: parseIsoDate(portfolio.endAt),
		note: portfolio?.note ?? DEFAULTS.note,
	};
};
